import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 311",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M276 9l227 227c11 11 11 29 0 40l-26 26a28 28 0 01-40 0L256 122 75 302a28 28 0 01-40 0L9 276a28 28 0 010-40L236 9c11-11 29-11 40 0z" })
});
export default SvgChevronUp;
